import { useState } from 'react'
import { PageHeader } from '../../components/ui/Card'
import { PermissionGate } from '../../components/PermissionGate'
import { useAuth } from '../../auth/AuthContext'
import { GeneralSettingsPanel } from './GeneralSettingsPanel'
import { DiscordSettingsPanel } from './DiscordSettingsPanel'
import { IntegrationsSettingsPanel } from './IntegrationsSettingsPanel'
import styles from '../projects/ProjectDetail.module.css'

type Tab = 'general' | 'discord' | 'integrations'

export function SettingsPage() {
  const { hasPermission } = useAuth()
  const [tab, setTab] = useState<Tab>('general')

  return (
    <div>
      <PageHeader title="Einstellungen" subtitle="Zentrale Panel-Konfiguration." />

      <div className={styles.tabs}>
        <button className={[styles.tab, tab === 'general' ? styles.tabActive : ''].join(' ')} onClick={() => setTab('general')}>
          Allgemein
        </button>
        {hasPermission('discord.manage') ? (
          <button className={[styles.tab, tab === 'discord' ? styles.tabActive : ''].join(' ')} onClick={() => setTab('discord')}>
            Discord
          </button>
        ) : null}
        {hasPermission('integrations.manage') ? (
          <button className={[styles.tab, tab === 'integrations' ? styles.tabActive : ''].join(' ')} onClick={() => setTab('integrations')}>
            Integrationen
          </button>
        ) : null}
      </div>

      {tab === 'general' ? <GeneralSettingsPanel /> : null}
      {tab === 'discord' ? (
        <PermissionGate anyOf={['discord.manage']}>
          <DiscordSettingsPanel />
        </PermissionGate>
      ) : null}
      {tab === 'integrations' ? (
        <PermissionGate anyOf={['integrations.manage']}>
          <IntegrationsSettingsPanel />
        </PermissionGate>
      ) : null}
    </div>
  )
}
